// Utility function for photo URLs
// Centralized to ensure consistency across the app

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Get the full photo URL from a relative or absolute path
 * @param {string} url - The photo URL (can be relative like /api/uploads/photos/... or absolute)
 * @param {boolean} bustCache - Add timestamp to bust cache (default: false)
 * @returns {string|null} The full URL or null if no URL provided
 */
export const getPhotoUrl = (url, bustCache = false) => {
  if (!url) return null;
  
  let fullUrl;
  
  // If it's a Cloudinary URL, return as-is (it's already a complete URL)
  if (url.includes('cloudinary.com') || url.includes('res.cloudinary.com')) {
    fullUrl = url;
  }
  // If URL starts with /, prepend the backend URL (without /api since the path already includes it)
  else if (url.startsWith('/api/')) {
    fullUrl = `${BACKEND_URL}${url}`;
  } else if (url.startsWith('/')) {
    fullUrl = `${BACKEND_URL}${url}`;
  } else if (url.startsWith('http')) {
    // Check if it's an old domain URL that needs fixing
    if (url.includes('spikemaster') || url.includes('preview.emergentagent.com')) {
      // Extract the path and use current backend
      const match = url.match(/\/api\/uploads\/photos\/[^/]+$/);
      if (match) {
        fullUrl = `${BACKEND_URL}${match[0]}`;
      } else {
        fullUrl = url;
      }
    } else {
      fullUrl = url;
    }
  } else {
    fullUrl = url;
  }
  
  // Add cache-busting parameter if requested (only for non-cloudinary URLs)
  if (bustCache && fullUrl && !fullUrl.includes('cloudinary.com')) {
    const separator = fullUrl.includes('?') ? '&' : '?';
    fullUrl = `${fullUrl}${separator}t=${Date.now()}`;
  }
  
  return fullUrl;
};

export default getPhotoUrl;
